import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class FbSummaryStatusDasboardCardService {

  constructor(private httpClient: HttpClient) { }
  encriptedData: string;

  getDetails(apiValue: string) { 
    // STATUS API    
    if(apiValue == 'EMPLOYEE'){
      apiValue = 'employee';
    }
    return this.httpClient.get(`/vd/formBuilder/${apiValue}/status`).pipe(
      map((response: any) => {
        if (response && response.status === 200) {
          return response.data;
        } else {
          return null
        }
      }),
      catchError(error => {
        return of(null);
      })
    );
  }

  getCheckInSummaryDetails(apiValue: string, encodedDate: string) {
    const fullPath = `${apiValue}/${encodedDate}`;
    var encryptedText = this.toEncrypt(apiValue); 
    return this.httpClient.get(`/vd/formBuilder/dashboard/${encryptedText}/${encodedDate}/checkInSummary`).pipe(
      map((response: any) => {
        if (response && response.status === 200) {
          return response.data;
        } else {
          return null
        }
      }),
      catchError(error => {
        return of(null);
      })
    );
  }
  toEncrypt(_data) {
    var pharase = 'c63a423527b24f65'
    var data = _data;
    var key  = CryptoJS.enc.Latin1.parse(pharase);
    var iv   = CryptoJS.enc.Latin1.parse(pharase);  
    var encrypted = CryptoJS.AES.encrypt(
      data,
      key,
      {iv:iv,mode:CryptoJS.mode.CBC,
        padding:CryptoJS.pad.ZeroPadding
    }).toString();

    var e64 = CryptoJS.enc.Base64.parse(encrypted);
    var eHex = e64.toString(CryptoJS.enc.Hex);

   return this.encriptedData = eHex
  }

}
